<template>
  <section id="trainers" class="py-5 bg-trainers">
    <div class="container position-relative">
      <h2 class="text-center display-5 fw-bold mb-5 section-title">
        <i class="bi bi-person-badge-fill text-warning"></i> Our Trainers
      </h2>

      <div class="row g-4 justify-content-center">
        <div 
          class="col-12 col-md-6 col-lg-4"
          v-for="(trainer, index) in trainers"
          :key="index"
        >
          <div 
            class="card trainer-card"
            :style="{ animationDelay: (Math.floor(index / 3) * 0.3 + (index % 3) * 0.15) + 's' }"
          >
            <div class="trainer-img-wrapper">
              <img :src="trainer.photo" :alt="trainer.name" class="trainer-img">
              <div class="overlay">
                <div class="overlay-icons">
                  <a v-if="trainer.social.facebook" :href="trainer.social.facebook" target="_blank"><i class="bi bi-facebook"></i></a>
                  <a v-if="trainer.social.tiktok" :href="trainer.social.tiktok" target="_blank"><i class="bi bi-tiktok"></i></a>
                  <a v-if="trainer.social.instagram" :href="trainer.social.instagram" target="_blank"><i class="bi bi-instagram"></i></a>
                  <a v-if="trainer.social.whatsapp" :href="trainer.social.whatsapp" target="_blank"><i class="bi bi-whatsapp"></i></a>
                  <a v-if="trainer.social.phone" :href="'tel:' + trainer.social.phone" target="_blank"><i class="bi bi-telephone-fill"></i></a>
                </div>
              </div>
            </div>

            <div class="card-body text-center d-flex flex-column">
              <h5 class="card-title gradient-text animate-name">{{ trainer.name }}</h5>
              <p class="card-text specialty animate-specialty">{{ trainer.specialty }}</p>

              <!-- Lista con scroll -->
              <ul class="description list-unstyled text-start mx-3 mt-2 flex-grow-1">
                <li v-for="(item, i) in trainer.description" :key="i" class="animate-desc" :style="{ transitionDelay: (i * 0.1) + 's' }">
                  <i class="bi bi-check2-circle text-warning me-2"></i>{{ item }}
                </li>
              </ul>

              <!-- Footer fijo con contacto -->
              <div class="contact-footer mt-3">
                <a :href="trainer.social.whatsapp || 'https://wa.me/584000000000'" target="_blank" class="btn btn-success w-100 d-flex align-items-center justify-content-center">
                  <i class="bi bi-whatsapp me-2"></i>
                  Contáctanos por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";

// Importar imágenes
import mujer from "../assets/images/trainers/mujer.webp";
import hombre1 from "../assets/images/trainers/hombre1.webp";
import mujer1 from "../assets/images/trainers/mujer1.webp";
import mujer3 from "../assets/images/trainers/mujer3.webp";
import alvaro from "../assets/images/trainers/alvaro.webp";
import hombre2 from "../assets/images/trainers/Hombre.webp";
import mujer2 from "../assets/images/trainers/mujer2.webp";
import andres from "../assets/images/trainers/andres (1).webp";
import hender from "../assets/images/trainers/hender.webp";

// Array de entrenadores
const trainers = [
  { name: "Francisbel G. Brito", photo: mujer, specialty: "Personal Trainer", description: ["Certificada por IDEL y UNERS","Sala de Musculación","Entrenamiento para Hipertrofia Muscular (INAF)","Planificación de entrenamiento"], social:{instagram:"https://instagram.com/francisbelbrito", whatsapp:"https://wa.me/584145557333"} },
  { name: "Carlos Veliz", photo: hombre1, specialty: "Personal Trainer & Nutrición Deportiva", description:["Certificado personal trainer por IFBB Academy Argentina","Instructor sala de musculación","Entrenamientos funcionales","Nutrición deportiva","Accesoría en suplementación"], social:{instagram:"https://instagram.com/Carlosveliz", facebook:"https://facebook.com/CarlosVeliz", whatsapp:"https://wa.me/584245451343"} },
  { name: "María Antonieta Méndez", photo: mujer1, specialty:"Personal Trainer", description:["Certificado personal Trainer por IDEL y UNERS","Sala de Musculación","Asesoría Nutricional","Planificación de entrenamiento"], social:{instagram:"https://instagram.com/anttomendez2402", facebook:"https://facebook.com/AntonietaMendez", phone:"04245080319"} },
  { name: "María Vivas", photo: mujer3, specialty:"Entrenadora Personalizada", description:["Objetivo: bienestar físico y mental del cliente","Certificada por IDEL y UNESR","Musculación y resistencia","Dietas y nutrición personalizadas","Circuitos de entrenamiento según fuerza y resistencia"], social:{instagram:"https://instagram.com/the_lokita_bella", whatsapp:"https://wa.me/584125257688"} },
  { name: "Álvaro Costero", photo: alvaro, specialty:"Licenciado en Educación Física", description:["Egresado de la Universidad Nacional Experimental Ezequiel Zamora","Certificación Internacional en Personal Trainer por INAF","Biomecánica, lesiones e hipertrofia","Planificación del entrenamiento y suplementación"], social:{facebook:"https://facebook.com/AlvaroCostero", instagram:"https://instagram.com/AlvaroCostero", tiktok:"https://tiktok.com/@Ajtrainer_29"} },
  { name: "Pedro Conde", photo: hombre2, specialty:"Personal Trainer Certificado", description:["Certificado como Personal Trainer por IDEL y UNERS","Especialista en sala de musculación","Asesoría nutricional adaptada","Fuerza, tonificación y acondicionamiento físico"], social:{facebook:"https://facebook.com/PedroConde", instagram:"https://instagram.com/pedroconde7", whatsapp:"https://wa.me/584121550251"} },
  { name: "Sara Barreto", photo: mujer2, specialty:"Preparadora Física y Personal Trainer", description:["Certificada por el Instituto de Deporte del Perú","Preparadora Física certificada en Venezuela","Sala de musculación y nutrición deportiva","Entrenamiento integral: fuerza, tonificación y rendimiento"], social:{instagram:"https://instagram.com/sarafittrainer", whatsapp:"https://wa.me/584245254820"} },
  {
    name: "Andrés Rosales",
    photo: andres,
    specialty: "Personal Trainer",
    description: [
      "Certificado en Personal Trainer por Therapeutic Venezuela Rehabilitation and Fitness",
      "Asesoría Personalizada",
      "Instructor de Sala de Musculación",
      "Planificación de Entrenamiento",
      "Bioenergética Nutricional",
      "Biomecánica Aplicada"
    ],
    social: {
      instagram: "https://instagram.com/andresrosales___",
      phone: "0412-7732342"
    }
  },
  {
    name: "Hender Requena",
    photo: hender,
    specialty: "Personal Trainer",
    description: [
      "Certificado como Personal Trainer por el Ministerio de Educación de la República Bolivariana de Venezuela",
      "Sala de Musculación",
      "Entrenamiento de Fuerza",
      "Suplementación Deportiva",
      "Fisiología del Ejercicio",
      "Biomecánica del Ejercicio",
      "Abordaje Nutricional y Elaboración de Menú"
    ],
    social: {
      facebook: "https://facebook.com/HenderRequena",
      instagram: "https://instagram.com/henderrquena",
      phone: "0412-5596314"
    }
  }
];

onMounted(() => {
  const observer = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add("visible");
      }
    });
  },{threshold:0.2});
  document.querySelectorAll(".trainer-card,.section-title,.animate-name,.animate-specialty,.animate-desc").forEach(el=>observer.observe(el));
});
</script>

<style scoped>
.bg-trainers {
  background-image: url("../assets/images/carruzel/gym1.webp");
  background-size: cover;
  background-position: center;
  padding-top: 5rem;
  padding-bottom: 5rem;
  position: relative;
}
.bg-trainers::before{
  content:"";
  position:absolute;
  top:0;left:0;right:0;bottom:0;
  background-color: rgba(0,0,0,0.55);
  z-index:0;
}
.container{position:relative; z-index:1;}

.section-title{
  color:#fff;
  text-shadow:1px 1px 10px rgba(0,0,0,0.7);
  opacity:0;
  transform: translateY(40px);
  transition: all 0.8s ease;
}
.section-title.visible{opacity:1; transform:translateY(0);}

.trainer-card{
  border:none; border-radius:20px;
  overflow:hidden;
  box-shadow:0 8px 25px rgba(0,0,0,0.2);
  background-color: rgba(255,255,255,0.97);
  opacity:0;
  transform: translateY(40px) scale(0.95) rotate(-1deg);
  transition: all 0.8s ease;
  display: flex;
  flex-direction: column;
}
.trainer-card.visible{opacity:1; transform:translateY(0) scale(1) rotate(0);}
.trainer-card:hover{transform:translateY(-10px) scale(1.05); box-shadow:0 12px 30px rgba(0,0,0,0.25);}

.trainer-img-wrapper{position:relative; overflow:hidden; margin:1rem auto 0; width:85%; border-radius:20px;}
.trainer-img{width:100%; aspect-ratio:4/5; object-fit:cover; transition: transform 0.5s ease;}
.trainer-img-wrapper:hover .trainer-img{transform:scale(1.08) translateY(-5px);}

.overlay{position:absolute; top:0; left:0; right:0; bottom:0; background-color: rgba(0,0,0,0.35); opacity:0; display:flex; justify-content:center; align-items:center; transition:opacity 0.35s ease; border-radius:inherit;}
.trainer-img-wrapper:hover .overlay{opacity:1;}
.overlay-icons i{font-size:1.6rem; margin:0 0.35rem; opacity:0; transform:translateY(25px); transition: all 0.35s ease;}
.trainer-img-wrapper:hover .overlay-icons i{opacity:1; transform:translateY(0);}

.gradient-text{background: linear-gradient(90deg,#F97316,#FBBF24,#F97316); -webkit-background-clip:text; -webkit-text-fill-color:transparent; animation: gradientMove 3s infinite linear; font-weight:700; font-size:1.35rem;}
@keyframes gradientMove{0%{background-position:0%;}100%{background-position:200%;}}

.animate-name, .animate-specialty, .animate-desc{
  opacity:0; transform:translateY(20px);
  transition: all 0.6s ease;
}
.animate-name.visible, .animate-specialty.visible, .animate-desc.visible{opacity:1; transform:translateY(0);}

.specialty{font-weight:600;color:#333;margin-bottom:0.5rem;}
.description li{font-size:0.95rem;color:#555;margin-bottom:0.5rem;}

/* Scroll en descripciones */
.description {
  max-height: 150px;
  overflow-y: auto;
  padding-right: 0.5rem;
}
.description::-webkit-scrollbar {
  width: 6px;
}
.description::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.05);
  border-radius: 10px;
}
.description::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 10px;
}
.description::-webkit-scrollbar-thumb:hover {
  background: rgba(0,0,0,0.35);
}

/* Footer fijo */
.contact-footer{
  margin-top: auto;
}

/* Responsive */
@media (max-width:1200px){
  .col-lg-4{flex:0 0 50%; max-width:50%;}
}
@media (max-width:768px){
  .col-lg-4{flex:0 0 100%; max-width:100%;}
}
</style>
